export default __webpack_public_path__ + "static/media/diskartech-logo.f618aba0.svg";